import { render } from "./headerNotification.vue?vue&type=template&id=47228437&scoped=true"
import script from "./headerNotification.vue?vue&type=script&lang=js"
export * from "./headerNotification.vue?vue&type=script&lang=js"

import "./headerNotification.vue?vue&type=style&index=0&id=47228437&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47228437"]])

export default __exports__